import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { BaseModelService } from './base-model.service'
import { PifiaReviewSerializer } from 'serializers/pifia-review.serializer'
import { PifiaReview } from './pifia-review.model'

@Injectable()
export class PifiaReviewService extends BaseModelService<PifiaReview> {
  constructor() {
    super()

    this.configure({
      basePath:  'pifia_reviews',
      key:       'pifiaReview',
      pluralKey: 'pifiaReviews',
      serializer: PifiaReviewSerializer
    })
  }

  index(): Observable<Object> {
    let url = this.buildUrl()
    return this.appHttp.get(url).map((response) => {
      return {
        reviews: response.json()
      }
    })
  }

  list(params?: Object): Observable<Object> {
    let url = this.buildUrl()
    return this.get(url, params)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/pifia-review.service.ts